import { agentBadge } from "../components/run.ts";
import { statusPill } from "../components/run.ts";
import { html, type Html } from "../html.ts";
import type { AppShellProps, NavProps } from "../shell.ts";
import type { ScreenOptions } from "./common.ts";
import { placeOf } from "./common.ts";
import { REPOS, USER } from "./fixtures.ts";

export const RAIL_NAV: NavProps = { active: "runs", repos: REPOS, user: USER, rail: true };
export const fullNav = (active: NavProps["active"], opts: ScreenOptions = {}): NavProps => {
  if (!opts.place) return { ...(active ? { active } : {}), repos: REPOS, user: USER };
  const place = placeOf(opts);
  return {
    ...(active ? { active } : {}),
    repos: place.repos,
    user: { firstName: place.user.firstName, initials: place.user.initials, ...(place.user.settingsHref ? { settingsHref: place.user.settingsHref } : {}) },
    ...(place.hrefs ? { hrefs: place.hrefs } : {}),
  };
};

/** Common shell options from screen options. */
export const shellOpts = (opts: ScreenOptions): Pick<AppShellProps, "theme"> & Partial<Pick<AppShellProps, "frame">> => ({ theme: opts.theme, ...(opts.frame ? { frame: opts.frame } : {}) });

/** Two-pane body: main plus a rail. `cols` sets the rail width. */
export const split = (main: Html | string, rail: Html | string, cols = "minmax(0, 1fr) 380px"): Html =>
  html`<div class="ap-split" style="--cols: ${cols};">${main}${rail}</div>`;

export const call = (n: number): string => `AX-${String(n).padStart(2, "0")}`;

export const unitInline = (n: number): Html => html`<span class="bt-unit">${agentBadge({ agent: n, size: "xs" })}<span class="bt-unit__call">${call(n)}</span></span>`;

export const pill = statusPill;

/** A centred panel for a state inside a screen body. */
export const centred = (content: Html): Html => html`<div class="ap-pane" style="flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 32px; gap: 16px;"><div style="width: 100%; max-width: 560px; display: flex; flex-direction: column; gap: 16px;">${content}</div></div>`;
